import React from 'react'
import styled from 'styled-components'
import ActionToggle from 'live/components/ui/action-toggle'

function Toggle({
    status,
    onChange,
    label,
    disabled = false,
    key
}: {
    status: boolean
    key: string
    disabled?: boolean
    onChange: (status: boolean) => void
    label: string
}) {
    return (
        <ToggleArea>
            <div data-cy={key}>
                <ActionToggle active={status} disabled={disabled} onChange={() => onChange(!status)} />
            </div>
            <label>{label}</label>
        </ToggleArea>
    )
}

const ToggleArea = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    margin-left: 7px;
    label {
        white-space: nowrap;
        margin-right: 7px;
        margin-left: 4px;
    }
    a {
        top: 0 !important;
    }
    div {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`

export { Toggle }
